export const siteSettings = {
  name: "Open Finance Stack",
  link: "https://openfinancestack.com",
  email: "support@openfinancestack.com",
  appLink: "https://app.openfinancestack.com",
};
